import usePagination from '../Paginator/hooks';

import styles from './TotalRecords.module.scss';

const TotalRecords = () => {
  const { totalRecords } = usePagination();

  return (
    totalRecords && (
      <div className={styles.totalRecords}>
        <div>
          {totalRecords}
          <span>results</span>
        </div>
      </div>
    )
  );
};

export default TotalRecords;
